<template>
  <div class="agreement-progress-bar">
    <div class="agreement-progress-bar__labels">
      <span class="agreement-progress-bar__title">Progreso</span>
      <span class="agreement-progress-bar__count">{{ summary.dues_paid }} de {{ agreement.dues_qty }} cuotas</span>
    </div>
    <div class="agreement-progress-bar__track">
      <div
        class="agreement-progress-bar__fill"
        :style="fillStyle">
      </div>
    </div>
  </div>
</template>

<script>
const PROGRESS_COLORS = {
  Activo: '#1D9E75',
  Incumplimiento: '#BA7517',
  Cancelado: '#A32D2D',
  Pagado: '#1D9E75',
};

export default {
  props: {
    agreement: {
      type: Object,
      required: true,
    },
    summary: {
      type: Object,
      required: true,
    },
  },
  computed: {
    percent() {
      if (!this.agreement.dues_qty) {
        return 0;
      }

      return Math.round((this.summary.dues_paid / this.agreement.dues_qty) * 100);
    },
    fillStyle() {
      const statusName = this.agreement.status ? this.agreement.status.name : '';
      const color = PROGRESS_COLORS[statusName] || '#1D9E75';

      return {
        width: `${this.percent}%`,
        backgroundColor: color,
      };
    },
  },
};
</script>

<style scoped>
.agreement-progress-bar {
  margin: 16px 0;
}

.agreement-progress-bar__labels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  color: #444441;
}

.agreement-progress-bar__title {
  font-weight: 600;
}

.agreement-progress-bar__track {
  height: 8px;
  background: #E8E6E1;
  border-radius: 4px;
  overflow: hidden;
}

.agreement-progress-bar__fill {
  height: 100%;
  border-radius: 4px;
  transition: width 300ms ease;
}
</style>



// WEBPACK FOOTER //
// src/components/agreements/AgreementProgressBar.vue